/* eslint-disable no-shadow */

'use client';

import { createTheme } from '@mui/material/styles';
import { BOX_SHADOW, COLORS } from './colorScheme';
import { BREAKPOINTS, BUTTON_VARIANTS, TYPOGRAPHY } from './themeConstants';

/**
 * @type {import('@mui/material/styles').PaletteOptions}
 */
const palette = {
  default: {
    backgroundColor: COLORS.gray150,
    backgroundColor2: COLORS.white,
    backgroundColor3: COLORS.gray250,
    backgroundColor4: COLORS.oat,
    backgroundColor5: COLORS.gray500,
    buttonColor: COLORS.sunset,
    buttonPrimaryHoverColor: COLORS.sunset30,
    buttonInactiveColor: COLORS.gray550,
    linkColor: COLORS.gray800,
    error: COLORS.redOrange,
    alert: COLORS.cherryVelvet,
    textColor: COLORS.white,
    textColor2: COLORS.oat,
    textColor3: COLORS.heather,
    textColor4: COLORS.jetBlack,
    textColor5: COLORS.heather80,
    textColor6: COLORS.purpleTaupe,
    boxShadow: BOX_SHADOW.boxShadow1Lite,
    boxShadow1: BOX_SHADOW.boxShadow1,
    boxShadow2: BOX_SHADOW.boxShadow4Lite,
    modalBoxShadow: BOX_SHADOW.boxShadow5Medium,
    modalBoxShadow2: BOX_SHADOW.boxShadow3Medium,
    scrollBarBoxShadow: BOX_SHADOW.boxShadow4,
  },
};

/**
 * @type {import('@mui/material/styles').Components}
 */
const createComponents = palette => ({
  MuiContainer: {
    styleOverrides: {
      root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
    },
  },
  MuiButton: {
    styleOverrides: {
      root: {
        color: palette.default.textColor,
        backgroundColor: palette.default.buttonColor,
        '&:hover': {
          backgroundColor: palette.default.buttonPrimaryHoverColor,
          color: palette.default.textColor,
        },
      },
    },
    variants: BUTTON_VARIANTS,
  },
  MuiCssBaseline: {
    styleOverrides: {
      body: {
        backgroundColor: palette.default.backgroundColor,
      },
      a: {
        color: palette.default.textColor3,
        textDecoration: 'none',
        cursor: 'pointer',
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },
  },
});

const theme = createTheme({
  typography: TYPOGRAPHY,
  palette,
  components: createComponents(palette),
  breakpoints: BREAKPOINTS,
});

export default theme;
